<template>
  <div id="app">
    <div class="layout-wrap">
      <HeaderMenu />
      <div class="content-wrap">
        <router-view></router-view>
      </div>
      <LayoutFooter />
      <button type="button" @click="moveToScrollTop" class="top-scroll">
        <img
          :src="require('./assets/img/top-scroll-arrow.png')"
          alt="스크롤 맨 위로 아이콘"
        />
      </button>
    </div>
  </div>
</template>

<script>
import "./assets/css/reset.css";
import HeaderMenu from "./components/layout/HeaderMenu.vue";
import LayoutFooter from "./components/layout/LayoutFooter.vue";

export default {
  name: "App",
  components: { HeaderMenu, LayoutFooter },

  methods: {
    moveToScrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style>
@font-face {
  font-family: "GmarketSansMedium" !important;

  src: url("https://fastly.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansMedium.woff?v=1")
    format("woff") !important;
  src: url("./assets/font/GmarketSansTTFBold.ttf") format("truetype") !important;
  src: url("./assets/font/GmarketSansTTFLight.ttf") format("truetype") !important;
  src: url("./assets/font/GmarketSansTTFMedium.ttf") format("truetype") !important;
  src: url("./assets/font/GmarketSansBold.otf") format("opentype") !important;
  src: url("./assets/font/GmarketSansLight.otf") format("opentype") !important;
  src: url("./assets/font/GmarketSansMedium.otf") format("opentype") !important;

  font-weight: normal;
  font-style: normal;
}

body,
html {
  font-family: "GmarketSansMedium" !important;
}
#app {
  width: 100%;
  font-family: "GmarketSansMedium";
}

.layout-wrap {
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.content-wrap {
  min-height: calc(100vh - 361px);
  position: relative;
}

.footer {
  height: 361px;
}

.top-scroll {
  position: fixed;
  bottom: 40px;
  right: 41px;
  display: inline-block;
  z-index: 3;

  @media only screen and (max-width: 1040px) {
    & img {
      width: 60px;
      height: 60px;
    }
  }
}
</style>
